import { type Locale } from "@/domain";
import { type PcEnvironment } from ".";

export interface PowerReviewsLocaleCredentials {
	apiKey: string;
	merchantGroupId: string;
	merchantId: string;
}

export interface PowerReviewsConfig {
	scriptUrl: string;
	byLocale: Record<Locale, PowerReviewsLocaleCredentials>;
}

export function loadPowerReviewsConfig(
	pcEnvironment: PcEnvironment
): PowerReviewsConfig {
	const sharedScriptUrl = "https://ui.powerreviews.com/stable/4.0/ui.js";

	const NON_PROD_CONFIG = {
		scriptUrl: sharedScriptUrl,
		usMerchantGroupId: "48675",
		usMerchantId: "273515",
		caMerchantGroupId: "49178",
		caMerchantId: "25092"
	};

	const PROD_CONFIG = {
		scriptUrl: sharedScriptUrl,
		usMerchantGroupId: "48781",
		usMerchantId: "658501",
		caMerchantGroupId: "49314",
		caMerchantId: "401937"
	};

	const defaults = pcEnvironment === "prod" ? PROD_CONFIG : NON_PROD_CONFIG;

	const {
		PR_US_API_KEY,
		PR_CA_API_KEY,
		PR_SCRIPT_URL,
		PR_US_MERCHANT_GROUP_ID,
		PR_US_MERCHANT_ID,
		PR_CA_MERCHANT_GROUP_ID,
		PR_CA_MERCHANT_ID
	} = process.env;
	if (!PR_US_API_KEY || !PR_CA_API_KEY) {
		throw new Error(
			"PowerReviews API keys are not set. Required env vars: PR_US_API_KEY, PR_CA_API_KEY"
		);
	}

	// service-configuration-* injects PR_SCRIPT_URL and the merchant ids per
	// environment; the hardcoded values only cover setups missing those vars.
	return {
		scriptUrl: PR_SCRIPT_URL ?? defaults.scriptUrl,
		byLocale: {
			"en-US": {
				apiKey: PR_US_API_KEY,
				merchantGroupId:
					PR_US_MERCHANT_GROUP_ID ?? defaults.usMerchantGroupId,
				merchantId: PR_US_MERCHANT_ID ?? defaults.usMerchantId
			},
			"en-CA": {
				apiKey: PR_CA_API_KEY,
				merchantGroupId:
					PR_CA_MERCHANT_GROUP_ID ?? defaults.caMerchantGroupId,
				merchantId: PR_CA_MERCHANT_ID ?? defaults.caMerchantId
			}
		}
	};
}
